"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = exports.Radio = exports.Checkbox = exports.Basic = void 0;

var _react = require("@emotion/react");

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _propTypes = require("prop-types");

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));

var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));

var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));

var _svg = require("./svg");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Basic = function Basic(props) {
  return (0, _jsxRuntime.jsx)(_FormControlLabel["default"], _objectSpread({}, props));
};

exports.Basic = Basic;

var Checkbox = function Checkbox(_ref) {
  var disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["disabled"]);

  return (0, _jsxRuntime.jsx)(Basic, _objectSpread(_objectSpread({}, props), {}, {
    control: (0, _jsxRuntime.jsx)(_Checkbox["default"], {
      checkedIcon: (0, _jsxRuntime.jsx)(_svg.CheckboxIcon.Checked, {}),
      color: "primary",
      icon: (0, _jsxRuntime.jsx)(_svg.CheckboxIcon.Unchecked, {
        disabled: disabled
      })
    }),
    disabled: disabled
  }));
};

exports.Checkbox = Checkbox;

var Radio = function Radio(_ref2) {
  var name = _ref2.name,
      options = _ref2.options,
      value = _ref2.value,
      props = _objectWithoutProperties(_ref2, ["name", "options", "value"]);

  return (0, _jsxRuntime.jsx)(_RadioGroup["default"], {
    name: name,
    value: value,
    children: options.map(function (option) {
      return (0, _react.createElement)(Basic, _objectSpread(_objectSpread({}, props), {}, {
        control: (0, _jsxRuntime.jsx)(_Radio["default"], {
          checkedIcon: (0, _jsxRuntime.jsx)(_svg.RadioIcon.Checked, {}),
          color: "primary",
          icon: (0, _jsxRuntime.jsx)(_svg.RadioIcon.Unchecked, {
            disabled: option.disabled
          })
        }),
        key: option.value,
        label: option.label,
        value: option.value,
        disabled: option.disabled
      }));
    })
  });
};

exports.Radio = Radio;

var Switch = function Switch(_ref3) {
  var _ref3$switchProps = _ref3.switchProps,
      switchProps = _ref3$switchProps === void 0 ? {
    color: 'primary'
  } : _ref3$switchProps,
      props = _objectWithoutProperties(_ref3, ["switchProps"]);

  return (0, _jsxRuntime.jsx)(Basic, _objectSpread(_objectSpread({}, props), {}, {
    control: (0, _jsxRuntime.jsx)(_Switch["default"], _objectSpread({}, switchProps))
  }));
};

exports.Switch = Switch;
Basic.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  labelPlacement: 'end'
};
Radio.propTypes = _objectSpread(_objectSpread({}, Basic.propTypes), {}, {
  options: (0, _propTypes.arrayOf)((0, _propTypes.exact)({
    disabled: _propTypes.bool,
    label: _propTypes.string.isRequired,
    value: _propTypes.string.isRequired
  }).isRequired).isRequired
});